/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StepConstraintDto
 */
export interface StepConstraintDto {
    /**
     * Key of the question this constraint refers to
     * @type {string}
     * @memberof StepConstraintDto
     */
    questionKey?: string;
    /**
     * Constraint operator (equals, not equals, etc.)
     * @type {string}
     * @memberof StepConstraintDto
     */
    operator?: string;
    /**
     * Single constraint value
     * @type {object}
     * @memberof StepConstraintDto
     */
    value?: object | null;
    /**
     * Multiple constraint values
     * @type {Array<object>}
     * @memberof StepConstraintDto
     */
    values?: Array<object> | null;
}

/**
 * Check if a given object implements the StepConstraintDto interface.
 */
export function instanceOfStepConstraintDto(value: object): value is StepConstraintDto {
    return true;
}

export function StepConstraintDtoFromJSON(json: any): StepConstraintDto {
    return StepConstraintDtoFromJSONTyped(json, false);
}

export function StepConstraintDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepConstraintDto {
    if (json == null) {
        return json;
    }
    return {
        
        'questionKey': json['questionKey'] == null ? undefined : json['questionKey'],
        'operator': json['operator'] == null ? undefined : json['operator'],
        'value': json['value'] == null ? undefined : json['value'],
        'values': json['values'] == null ? undefined : json['values'],
    };
}

export function StepConstraintDtoToJSON(json: any): StepConstraintDto {
    return StepConstraintDtoToJSONTyped(json, false);
}

export function StepConstraintDtoToJSONTyped(value?: StepConstraintDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionKey': value['questionKey'],
        'operator': value['operator'],
        'value': value['value'],
        'values': value['values'],
    };
}

